import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { umsSideNav } from './components/sidenav/sidenav.component'
import { switchCustomerConfig } from './components/switch-customer/switch-customer.component'
import { customerParentComponent } from './containers/parent/parent.component'
import { customersParentState, customersState } from './customers.states.js'

const customersModule = {
  components: { customerParentComponent, umsSideNav },
  states: [customersParentState, customersState],
  configBlocks: [switchCustomerConfig],
}

loadNg1Module(ngmodule, customersModule)



// WEBPACK FOOTER //
// ./app/customers/customers.module.js